import { forwardRef } from "react";

import Icon from "@/components/Icon";
import NumberedListSVG from "./NumberedListSVG.svg.jsx";

const NumberedListIcon = forwardRef((props, ref) => {
  return <Icon {...props} ref={ref} SvgComponent={NumberedListSVG} />;
});

export default NumberedListIcon;
